import axios from "axios";

export const onLanguageHandle = (lang, i18n) => {
  console.log(lang);
  i18n.changeLanguage(lang);

  localStorage.setItem("lang", lang);
  axios.defaults.headers.common["Accept-Language"] = lang;

  // window.location.reload();
};
